/**
 * Navigation Configuration
 * Centralized nav items for consistent navigation across the app
 */

export interface NavItem {
  label: string;
  path?: string;
  scrollTo?: string;
}

export const PUBLIC_NAV_ITEMS: NavItem[] = [
  { label: 'Home', path: '/', scrollTo: 'home' },
  { label: 'Invest', path: '/invest' },
];

export const LANDING_NAV_ITEMS: NavItem[] = [
  { label: 'Home', scrollTo: 'home' },
  { label: 'Invest', path: '/invest' },
  { label: 'Hive Fund', path: '/hive-fund' },
  { label: 'About', path: '/about' },
  { label: 'Contact', scrollTo: 'contact' },
];

export const INVEST_NAV_ITEMS: NavItem[] = [
  { label: 'Home', path: '/' },
  { label: 'Invest', path: '/invest' },
  { label: 'Hive Fund', path: '/hive-fund' },
];
